// Lodash
window._ = require('lodash');

// axios
window.axios = require('axios');
require('promise.prototype.finally').shim();
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Default API URL
window.axios.defaults.baseURL = process.env.ROOT_API;
window.axios.defaults.headers.post['Content-Type'] = 'application/json';

// Interceptor to send the JWT with each request, if it exists
window.axios.interceptors.request.use((config) => {
  const token = window.$cookies.get('authToken');
  if (token != null) {
    config.headers.common['Authorization'] = 'Bearer ' + token;
  }

  return config;
}, (err) => {
  return Promise.reject(err);
});

window.axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response && error.response.status === 401 && error.response.data.message == "Expired JWT Token") {
    window.location = '/logout';
  } else {
    return Promise.reject(error);
  }
});



// WEBPACK FOOTER //
// ./src/init.js